import React from 'react';
import styled from '@emotion/styled';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface Props {
  value: {
    _key: string;
    _type: 'anchor';
    type: 'anchor';
    id: string;
  };
}

export const AnchorBlock = ({ value: { id } }: Props) => <Anchor id={id} />;

export const AnchorSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: Props) => (
      <ArticleBlockContentGridCol>
        <AnchorBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: Props) => <AnchorBlock value={value} />;
};

const Anchor = styled.div`
  height: 0;
  width: 0;
`;
